import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import MaterialEntryForm from "../../components/materialLines/MaterialEntryForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearMaterialOrderPartyInfo,
  fetchMaterialOrderMaterials,
  fetchMaterialOrderParties,
  fetchMaterialOrderPartyInfo,
  getMaterialOrderMaterials,
  getMaterialOrderMaterialsLoading,
  getMaterialOrderPartyInfo,
  getMaterialOrderPartyOptions,
} from "../../features/materialOrders/materialOrdersSlice";
import { POST } from "../../services/axios.service";
import { linePayload } from "../../static/materialLine";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { IMaterialLinesFormInput } from "../../types/materialLine";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "મટીરીયલ ઓર્ડર", href: route.materialOrders },
  { label: "નવો ઓર્ડર" },
];

const MaterialOrderCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partyOptions = useAppSelector(getMaterialOrderPartyOptions);
  const materials = useAppSelector(getMaterialOrderMaterials);
  const materialsLoading = useAppSelector(getMaterialOrderMaterialsLoading);
  const partyInfo = useAppSelector(getMaterialOrderPartyInfo);

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchMaterialOrderParties());
    dispatch(fetchMaterialOrderMaterials());
    dispatch(clearMaterialOrderPartyInfo());
  }, [dispatch]);

  const handlePartyChange = useCallback(
    (partyId: number) => {
      if (partyId) {
        dispatch(fetchMaterialOrderPartyInfo({ party_id: partyId }));
      } else {
        dispatch(clearMaterialOrderPartyInfo());
      }
    },
    [dispatch]
  );

  const handleSubmit = async (data: IMaterialLinesFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/material-orders", {
        party_id: data.party_id,
        date: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
        items: linePayload(data.items, false),
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.materialOrders);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવો મટીરીયલ ઓર્ડર ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <MaterialEntryForm
          partyOptions={partyOptions}
          materials={materials}
          materialsLoading={materialsLoading}
          partyInfo={partyInfo}
          onPartyChange={handlePartyChange}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={() => navigate(route.materialOrders)}
          submitLabel="સાચવો"
        />
      </div>
    </AppLayout>
  );
};
export default MaterialOrderCreatePage;
